module.exports = __webpack_public_path__ + "img/id.d50b2228.png";